<template>
    <v-dialog
        ref="dialog"
        v-model="dialog"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        :disabled="disabled"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="string"
                :label="label"
                :placeholder="placeholder"
                :hint="hint"
                persistent-hint
                v-bind="attrs"
                :error-messages="error"
                @blur="date = parseDate(string)"
                v-on="on"
                :disabled="disabled"
            />
        </template>
        <v-date-picker
            ref="picker"
            v-model="date"
            :max="getMax"
            :min="getMin"
            :hint="hint"
            no-title
            @input="dialog = false"
            locale="ES-cl"
            :disabled="disabled"
            :allowed-dates="val => allowed(val)"
        />
    </v-dialog>
</template>

<script>
export default {
    props: ["label", "placeholder", "value", "error", "max", "min", "disabled", "hint", "allowedDates"],
    data() {
        return {
            string: "",
            dialog: false,
            date: new Date().toISOString().substr(0, 10)
        };
    },
    created() {
        this.string = this.value;
    },
    watch: {
        date(val) {
            this.string = this.formatDate(this.date);
            this.$emit("input", this.string);
        },
        dialog(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    computed: {
        getMin() {
            if (this.min) {
                return this.min;
            }
            return undefined;
        },
        getMax() {
            if (this.max) {
                return this.max;
            }
            return undefined;
        }
    },
    methods: {
        allowed(date) {
            if (!this.allowedDates) return true;
            const sinceDate = new Date(this.allowedDates);
            const dateAsk = new Date(date);
            
            let days = ((dateAsk.getTime() - sinceDate.getTime()) / (1000 * 3600 * 24));
            const userString = localStorage.getItem("user");
            let user = JSON.parse(userString).user;
            if (user.role === "sysadmin") return (days >= 0 && days < 365);
            return (days >= 0 && days < process.env.VUE_APP_DAYS_TO_EXPIRE_OFFERS);
        },
        parseDate: function(date) {
            this.$emit("blur");
            if (!date) return null;
            const [day, month, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        formatDate: function(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
    }
};
</script>
